(function(runtime) {
    var _ = runtime.components.dependencies._;

    var constants = runtime.components.constants.merge({
        hiddenLabelPrefix: 'Hidden Input'
    });

    var statics = {
        hiddenTmpl: '<div class="ixp-component-textbox ixp-component-textbox-inherit" > \
            <div class="ixp-component-hidden-input-overlay">\
                <span class="ixp-component-hidden-input-label"></span>\
            </div>\
            <div class="ixp-component-textbox-input-wrap"> \
                <input data-ixp-textbox-type="text" type="text" class="ixp-component-textbox-input" maxlength="60" tabindex="-1"> \
            </div> \
        </div>'
    };

    runtime.components.register('ixp-hidden-input', runtime.components.InputComponentBase, {
        initialize: function(options) {
            if (this.inStudio) {
                this._updatePlaceholder();
                this.setInStudioDataFieldValidation();
            }
            this._setInitialValue(this.defaultValue);

            if (!this.inStudio) {
                this.$el.hide();
                runtime.events.on(this, this.formInstanceId + constants.inputs.events.formSubmitting, this._onFormSubmitting);
            } else {
                runtime.events.on(this, this.instanceId + constants.inputs.events.inputStateChanged, this._onInputStateChanged);
            }
        },

        onRegisterDataField: function() {
            var attrs = {};

            var nameAttr = this.inputAttrName || this.dataContext.name;
            if (nameAttr) {
                attrs.name = nameAttr;
            }

            if (this.inputAttrId) {
                attrs.id = this.inputAttrId;
            }

            if (this._initValue === undefined) {
                attrs.value = this._initValue;
            }

            return attrs;
        },

        _updatePlaceholder: function() {
            if (!this.$placeholder) {
                this.$placeholder = this.$(statics.hiddenTmpl);
                this.$el.append(this.$placeholder);
            }
            var $label = this.$placeholder.find('.ixp-component-hidden-input-label');

            var labelTxt = constants.hiddenLabelPrefix;
            if (this.dataContext.name) {
                labelTxt += ': ' + this.dataContext.name;
            }
            $label.html(labelTxt);
            $label.attr('title', labelTxt);

            var elClasses = this.$el.attr('class').split(' ');
            if (elClasses.length) {
                var classesToApply = ['ixp-component-textbox', 'ixp-component-textbox-inherit'];
                while (elClasses.length) {
                    var className = elClasses.shift();
                    switch (className) {
                        case 'ixp-component-hidden-input':
                        case 'ixp-input':
                        case 'ixp-input-validate':
                        case 'ixp-input-required':
                        case 'ui-draggable':
                        case 'pe-element-drag':
                            continue;
                        default:
                            classesToApply.push(className);
                    }
                }
                this.$placeholder.attr('class', classesToApply.join(' '));
            }
        },

        _onFormSubmitting: function() {
            this.setValue(this.getValue(), {trigger: false, submitting: true});
        },

        _onInputStateChanged: function() {
            this._updatePlaceholder();
        },

        getValue: function () {
            if (this.$shadowInput) {
                return this.$shadowInput.val();
            }
            return this._initValue;
        },

        onSetValue: function(value) {
            if (this.$shadowInput) {
                this.$shadowInput.val(value);
            } else {
                this._initValue = value;
            }
        },

        _setInitialValue: function(defaultValue) {
            var value;
            switch (this.defaultValueType) {
                case 'none':
                    value = '';
                    break;

                case 'datafield':
                    if (!this.inStudio) {
                        if (this.dataContext.hasValue) {
                            defaultValue = this.dataContext.value;
                        } else if (this.dataContext.hasDefaultValue) {
                            defaultValue = this.dataContext.defaultValue;
                        }
                    }

                    value = defaultValue;
                    break;

                case 'custom':
                    value = defaultValue;
                    break;
            }

            this.setValue(value);
            this.validate(value);
        },

        onStudioStateChanged: function() {
            var state = this.studioApp.state;
            var placeholdersHidden = (state.pagePlaceholders === 'hidden');
            this.$el.toggle(!placeholdersHidden);
        },

        allowedDropTargets: function(origin) {
            // this is not necessary for hidden input, they get no scaffolding anyway
            //if (origin === 'element'){
            //    return ['ixp-form-field'];
            //}
            return ['ixp-form', 'ixp-form-field'];
        }
    });
})(window.ixp.runtime);